export default __webpack_public_path__ + "static/media/component_data.7bfc3446.webp";